/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "NetworkTokenData": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "issuingNetwork": {
                "type": "squareup.common.NetworkTokenData.IssuingNetwork",
                "id": 2,
                "rule": "optional"
              },
              "status": {
                "type": "squareup.common.NetworkTokenData.Status",
                "id": 3,
                "rule": "optional"
              },
              "tokenRequestorId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "tokenPanSuffix": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "tokenExpirationYymm": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "paymentAccountReference": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "tokenPanFideliusToken": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "panSuffix": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "panExpirationYymm": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "panFideliusToken": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "mastercardMetadata": {
                "type": "squareup.common.MastercardMetadata",
                "id": 12
              },
              "visaMetadata": {
                "type": "squareup.common.VisaMetadata",
                "id": 13
              },
              "amexMetadata": {
                "type": "squareup.common.AmexMetadata",
                "id": 14
              }
            },
            "nested": {
              "IssuingNetwork": {
                "values": {
                  "MASTERCARD": 0,
                  "VISA": 1,
                  "AMEX": 2
                }
              },
              "Status": {
                "values": {
                  "PENDING": 0,
                  "ACTIVE": 1,
                  "SUSPENDED": 2,
                  "DEACTIVATED": 3,
                  "INELIGIBLE": 4
                }
              },
              "metadata": {
                "oneof": ["mastercardMetadata", "visaMetadata", "amexMetadata"]
              }
            }
          },
          "MastercardMetadata": {
            "fields": {}
          },
          "VisaMetadata": {
            "fields": {
              "panEnrollmentId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "tokenRequestorId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "tokenReferenceId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "AmexMetadata": {
            "fields": {}
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.NetworkTokenData && !$root.nested?.squareup?.nested?.common?.nested?.NetworkTokenData?.nested?.IssuingNetwork && !$root.nested?.squareup?.nested?.common?.nested?.NetworkTokenData?.nested?.Status && !$root.nested?.squareup?.nested?.common?.nested?.MastercardMetadata && !$root.nested?.squareup?.nested?.common?.nested?.VisaMetadata && !$root.nested?.squareup?.nested?.common?.nested?.AmexMetadata) {
  $root.addJSON(jsonData);
}

/**
 * Data for network card tokenization
 * Fields in this message should match the fields in squareup.tokenhandler.NetworkTokenData
 *
 * SOURCE NetworkTokenData @ squareup/common/network_token.proto at 11:1
 */
export const NetworkTokenData = $root.lookupType('squareup.common.NetworkTokenData');
fixType(NetworkTokenData, {
  id: {
    notEmpty: true
  },
  issuingNetwork: {
    required: true
  },
  status: {
    required: true
  },
  tokenRequestorId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(NetworkTokenData);
/**
 * Token Asset Information
 * TODO(jpm): once we need to expose this, token asset information should be
 * exposed here.
 *
 * SOURCE IssuingNetwork @ squareup/common/network_token.proto at 70:3
 */
NetworkTokenData.IssuingNetwork = $root.lookupEnum('squareup.common.NetworkTokenData.IssuingNetwork').values;
/**
 * SOURCE Status @ squareup/common/network_token.proto at 78:3
 */
NetworkTokenData.Status = $root.lookupEnum('squareup.common.NetworkTokenData.Status').values;
/**
 * SOURCE MastercardMetadata @ squareup/common/network_token.proto at 102:1
 */
export const MastercardMetadata = $root.lookupType('squareup.common.MastercardMetadata');
fixType(MastercardMetadata);
Builder.createAndAttachToType(MastercardMetadata);
/**
 * SOURCE VisaMetadata @ squareup/common/network_token.proto at 106:1
 */
export const VisaMetadata = $root.lookupType('squareup.common.VisaMetadata');
fixType(VisaMetadata, {
  panEnrollmentId: {
    notEmpty: true
  },
  tokenRequestorId: {
    notEmpty: true
  },
  tokenReferenceId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(VisaMetadata);
/**
 * SOURCE AmexMetadata @ squareup/common/network_token.proto at 124:1
 */
export const AmexMetadata = $root.lookupType('squareup.common.AmexMetadata');
fixType(AmexMetadata);
Builder.createAndAttachToType(AmexMetadata);